/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditEndpointObservability {
    getFixupPrototypeFunction() { return RequestAuditEndpointObservability.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditEndpointObservability>): RequestAuditEndpointObservability {
        let obj = Object.assign(new RequestAuditEndpointObservability(), model);
        RequestAuditEndpointObservability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditEndpointObservability>): RequestAuditEndpointObservability {
        if (!model) return null;
        return RequestAuditEndpointObservability.newInstance(<RequestAuditEndpointObservability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditEndpointObservability) {
        if (!obj) return;

        models.RequestAuditEndpointObservability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditEndpointObservability): boolean {
        Object.setPrototypeOf(obj, RequestAuditEndpointObservability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.stages) {
            models.RequestAuditObservabilityStages.fixupPrototype(this.stages);
        }
        if (this.pool_stats) {
            for (let val of this.pool_stats) {
                models.RequestAuditPoolServerStats.fixupPrototype(val);
            }
        }
    }

    /**
     * Compressed request payload (zstd + base64).
     */
    payload: string;

    /**
     * MongoDB connection pool stats at request entry.
     */
    pool_stats: Array<models.RequestAuditPoolServerStats>;

    /**
     * Stage-level timing breakdown.
     */
    stages: models.RequestAuditObservabilityStages;

    /**
     * Memoization cache key (SHA-256).
     */
    cache_key: string;

    /**
     * Whether served from memoization cache.
     */
    cache_hit: boolean;

}
